
































import './KisweIcon.scss'
import { computed, defineComponent, toRef } from '@vue/composition-api'
import { useThemes } from '../../compositions'
import { KisweSpin, KisweTheme } from '../../types'

export default defineComponent({
  name: 'KisweIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    scale: {
      type: String,
      required: false
    },
    spin: {
      type: String as () => KisweSpin,
      required: false,
      default: () => KisweSpin.Off,
      validator: (value: KisweSpin) => Object.values(KisweSpin).includes(value)
    },
    ...useThemes({ theme: KisweTheme.None }).props
  },
  emits: {
    // TODO: remove click handler, doesn't make sense on an icon... Should use button with an icon inside.
    click (_event: MouseEvent) { return true }
  },
  setup (props, { emit }) {
    const name = toRef(props, 'name')
    const isFontAwesome = computed(() => name.value.startsWith('fa-'))
    const iconName = computed(() => isFontAwesome.value ? name.value.slice(3) : name.value)

    return {
      iconName,
      isFontAwesome,
      loadedComponent: computed(() => require(`@/assets/icons/${name.value}.svg`)),
      onClick: (event: MouseEvent) => emit('click', event)
    }
  }
})
